// extracted by mini-css-extract-plugin
export default {"icon3d":"Icon3d_icon3d__66Ozy"};